import request from "@/utils/request";

export default function list(specificationId) {
    return request({
        url: `/storeProductSpecificationValue/agency/list/`+specificationId,
        method: 'get',
    })
}
